import { useState } from 'react';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { ExecFinancial } from '../components/widgets/ExecFinancial';
import { ExecProfit } from '../components/widgets/ExecProfit';
import { T } from '../theme/tokens';

/* Two financial views on one dashboard, because they are two halves of one question.
   "רווחיות" is where this month's money actually came from and what it cost to earn;
   "תחזית" is the approved plan and how the year is tracking against it.
   Same `financial` permission — whoever may see one may see the other. */
const TABS = [
  { id: 'profit', label: 'רווחיות' },
  { id: 'plan', label: 'תחזית מול תוכנית' },
] as const;

/* A segmented control rather than two buttons: the pair reads as one choice with a
   current position, which is what a tab strip is. The active segment carries the
   weight — filled, white text, raised — so it never needs a label saying "נבחר". */
function Tabs({ tab, onTab }: { tab: string; onTab: (t: 'profit' | 'plan') => void }) {
  return (
    <div style={{
      display: 'inline-flex', background: T.bg, border: `1px solid ${T.border}`,
      borderRadius: 9, padding: 3, gap: 3,
    }}>
      {TABS.map((t) => {
        const active = tab === t.id;
        return (
          <button
            key={t.id}
            onClick={() => onTab(t.id)}
            aria-pressed={active}
            style={{
              fontSize: 12.5, fontWeight: active ? 700 : 500,
              color: active ? '#FFFFFF' : T.inkSoft,
              background: active ? T.ink : 'transparent',
              border: 'none', borderRadius: 7, padding: '6px 14px', cursor: 'pointer',
              transition: 'background .12s ease, color .12s ease',
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

export default function ExecFinancialPage() {
  const [tab, setTab] = useState<'profit' | 'plan'>('profit');
  return (
    <div style={{ display: 'flex', height: '100vh', background: T.bg }}>
      <Sidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>
        <Header title="דשבורד פיננסי ותפעולי" subtitle="נתונים שמובילים להשפעה אמיתית">
          <Tabs tab={tab} onTab={setTab} />
        </Header>
        <main style={{ flex: 1, overflowY: 'auto', padding: '18px 24px 32px' }} dir="rtl">
          {tab === 'profit' ? <ExecProfit /> : <ExecFinancial />}
        </main>
      </div>
    </div>
  );
}
